import React, { Component } from "react";

import { withFilterCars } from "../../../shared/containers/containerFilterCars";
import { withCarsGroups } from "../../../shared/containers/containerCarsGroups";

import MultiSelects from "../../../shared/items/contols/multiSelect";
import FilterCarsItems from "./static.filterCarsItems";
import { getCarsGroupsSelectObj } from "./../../../shared/services/service.carsGroups";

import { states as queriesStates } from "./../../../reducers/queriesStates";
import { withCompanyGroups } from "../../../shared/containers/containerCompanyGroups";

class CarsGroupsFilter extends Component {
  componentDidMount() {
    const { onGetCompanyGroups, companyGroupsDataState } = this.props;

    if (companyGroupsDataState === queriesStates.NOT_REQUESTED) {
      onGetCompanyGroups();
    }
  }

  render() {
    const { onHandleChangeStore, filterCarsListItems, companyGroups } = this.props;
    const name = FilterCarsItems.groups.name;

    return (
      <MultiSelects
        name={name}
        valueStore={filterCarsListItems}
        options={getCarsGroupsSelectObj(companyGroups)}
        handleChange={onHandleChangeStore.bind(this, "groups")}
        placeholder="Выберите группу(ы)"
      />
    );
  }
}

export default withCompanyGroups(withFilterCars(CarsGroupsFilter));
